import { render } from "./Budaya.vue?vue&type=template&id=65cfe95c"
import script from "./Budaya.vue?vue&type=script&lang=js"
export * from "./Budaya.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__